import { render, staticRenderFns } from "./net_bar_stv.vue?vue&type=template&id=8d45504e&scoped=true&"
import script from "./net_bar_stv.vue?vue&type=script&lang=js&"
export * from "./net_bar_stv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d45504e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d45504e')) {
      api.createRecord('8d45504e', component.options)
    } else {
      api.reload('8d45504e', component.options)
    }
    module.hot.accept("./net_bar_stv.vue?vue&type=template&id=8d45504e&scoped=true&", function () {
      api.rerender('8d45504e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/net_bar_stv.vue"
export default component.exports